import Cookies from 'js-cookie';
import { LanguageType } from '@/interface/enum';
import { i18n } from '@/libraries/i18n';
import { getHost } from '@/libraries/url';

export enum Backdoor {
    None,
    India,
    Brazil,
}

const getEuroBackdoorType = () => {
    const query = new URLSearchParams(window.location.search);
    const backdoor = query.get('bd');
    if (backdoor) {
        if (backdoor === 'none') {
            Cookies.remove('bd', { domain: getHost() });
        } else {
            Cookies.set('bd', backdoor, { domain: getHost() });
        }
    }
    return Cookies.get('bd');
};

export default {
    getBackdoor(): Backdoor {
        const backdoor = getEuroBackdoorType() ?? '';
        const backdoorEnumMapping: Record<string, Backdoor> = {
            virat: Backdoor.India,
            neymar: Backdoor.Brazil,
        };

        return backdoorEnumMapping[backdoor] ?? Backdoor.None;
    },
    isTamilAndHindiLanguage() {
        return i18n.locale.value === LanguageType.TA_IN || i18n.locale.value === LanguageType.HI_IN;
    },
};
